module.exports = __webpack_public_path__ + "static/partners-3680c9f854f34d3093d66e669309f661.png";